import { Block } from 'factories/block';
import { Mirror } from 'store/mirror';
import { remoteable } from 'store/next';
import { setBlockLocalAction } from './setBlockLocalAction';

export const setBlockAction = (block: Block): any => {
  return (dispatch, getState) => {
    const s = getState();
    block.project_id = s.projectId;
    block.__isSaving = true;

    dispatch(setBlockLocalAction(block));

    if (remoteable()) {
      Mirror(dispatch, getState);
    }
  };
};
